import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import {
  Root,
  Title,
  Desc,
  StyledLink,
  Actions,
  Button,
} from './CookieDisclaimer.style';

const CookieDisclaimer = () => {
  const [cookies, setCookie] = useCookies(['cookieDisclaimer']);
  const [isShowDisclaimer, setIsShowDisclaimer] = useState(false);
  const [isRunAnimation, setIsRunAnimation] = useState(false);

  useEffect(() => {
    if (cookies.cookieDisclaimer !== 'dismissed') setIsShowDisclaimer(true);
  }, [cookies.cookieDisclaimer]);

  const onHideDisclaimer = () => {
    setIsRunAnimation((prevState) => !prevState);

    setTimeout(() => {
      setIsShowDisclaimer(false);
    }, 500);
  };

  const handleHideDisclaimer = () => {
    setCookie('cookieDisclaimer', 'dismissed', {
      path: '/',
      secure: true,
      maxAge: 365 * 24 * 60 * 60,
      domain: (import.meta.env.VITE_FRONTEND_DOMAIN || 'localhost').split(
        ':'
      )[0],
    });

    onHideDisclaimer();
  };

  return (
    isShowDisclaimer && (
      <Root $isShow={isShowDisclaimer} $isHide={isRunAnimation}>
        <Title>Cookie consent</Title>
        <Desc>
          We use cookies to operate our services. We also share information
          about your use of our site with our advertising and analytics partners
          in the United States. By clicking "Accept," you agree to our use of
          cookies.{' '}
          <StyledLink as={Link} to="/cookies">
            Cookie Policy
          </StyledLink>
          .
        </Desc>

        <Actions>
          <Button className="--outline" onClick={onHideDisclaimer}>
            Reject
          </Button>
          <Button className="--solid" onClick={handleHideDisclaimer}>
            Accept
          </Button>
        </Actions>
      </Root>
    )
  );
};

export default CookieDisclaimer;
